import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import {StytchProvider, initStytch} from '@stytch/stytch-react';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

const stytch = initStytch('public-token-test-8f8ff4ac-56cb-43d7-ad0e-8bfa22ab64fe')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <StytchProvider stytch={stytch}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </StytchProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
